import PropTypes from 'prop-types';
import React from 'react';
import { style } from '../Button';

const formStyle = {
  maxWidth: '500px',
  width: '100%',
  margin: '0 auto',
  padding: '30px 0',
  textAlign: 'center',
  boxSizing: 'border-box',
};

const Form = ({ children, onSubmit, button }) => (
  <form onSubmit={onSubmit} style={formStyle}>
    {children}
    <div style={{ textAlign: 'right', margin: '20px 0 0' }}>
      <button style={{ ...style, marginRight: '0', background: 'var(--petrol-color)' }} type="submit">
        {button}
      </button>
    </div>
  </form>
);

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  button: PropTypes.string,
};

Form.defaultProps = {
  button: 'Send',
};

export default Form;
